<template>
  <b-card-code title="">
    <div class="row mb-2">
      <div class="col-lg-6">
        <h4>Aggregátorok listája</h4>
      </div>
      <div class="col-lg-6 text-right">
        <button
          class="btn btn-primary"
          @click="$router.push('/aggregators/create')"
        >
          Új aggregátor
        </button>
      </div>
      <div class="col-lg-12 mt-2 text-right">
        <b-badge
          variant="primary"
          class="mr-1"
        >
          Összes aggregátor: {{ rows.length }}
        </b-badge>
      </div>
    </div>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Name -->
        <div
          v-if="props.column.field === 'name'"
          class="text-nowrap"
        >
          <span
            class="text-nowrap"
            @click="selectedData = props.row;$bvModal.show('aggregator_data');getAggregatorDetails(props.row.id)"
          >
            {{ props.row.name }}
          </span>
        </div>

        <!-- Column: Service -->
        <span v-else-if="props.column.field === 'service'">
          <b-badge
            :variant="getNextServiceHours(props.row) > props.row.operating_hours ? 'success' : 'danger'"
            style="color: white !important;"
          >
            {{ getNextServiceText(props.row) }}
          </b-badge>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="$router.push(`/aggregators/edit/${props.row.id}`)">
                <feather-icon
                  icon="Edit2Icon"
                  size="16"
                  class="mr-50"
                />
                <span>Szerkesztés</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteThisAggregator(props.row.id)">
                <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="mr-50"
                />
                <span>Törlés</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">Megjelenítés</span>
            <b-form-select
              v-model="pageLength"
              size="sm"
              :options="['3','5','10', '25', '50']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap">-ig a {{ props.total }} elemet</span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <!-- Aggregator Details Modal -->
    <b-modal
      id="aggregator_data"
      title="Aggregátor adatai"
      size="lg"
      hide-footer
    >
      <b-row class="my-1 pl-1 pr-1">
        <b-col
          lg="12"
          class="mt-1"
        >
          <b>Aggregátor adatok</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Megnevezés: <b>{{ selectedData.name }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Gyártó: <b>{{ selectedData.brand }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Típus: <b>{{ selectedData.type }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Gyári szám: <b>{{ selectedData.manufacturing_number }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Üzemóra: <b>{{ selectedData.operating_hours }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Szervíz intervallum: <b>{{ selectedData.service_interval }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Következő szervíz: <b>{{ getNextServiceText(selectedData) }}</b>
        </b-col>
        <b-col
          lg="12"
          class="mt-3"
        >
          <hr>
          <b>Szervíz előzmények</b>
        </b-col>
        <b-col v-if="aggregatorServices.length === 0">
          <p class="text-muted">
            Még nincs rögzített szervíz.
          </p>
        </b-col>
        <b-col v-else>
          <table class="table table-responsive">
            <tr>
              <th><b>Szervíz neve</b></th>
              <th><b>Számlaszám</b></th>
              <th><b>Elvégzés dátuma</b></th>
              <th><b>Üzemóra szervízkor</b></th>
              <th><b>Szervíz intervallum</b></th>
              <th><b>Elvégzett szolgáltatások</b></th>
            </tr>
            <tr
              v-for="service_data in aggregatorServices"
              :key="service_data.id"
            >
              <td>{{ service_data.service_name }}</td>
              <td>{{ service_data.billing_number }}</td>
              <td>{{ service_data.date_of_completion }}</td>
              <td>{{ service_data.hour_at_the_time_of_service }}</td>
              <td>{{ service_data.service_interval }}</td>
              <td>
                <b-badge
                  v-for="service_name in service_data.name_of_service"
                  :key="service_name"
                  variant="primary"
                  class="mr-1 mb-1"
                  style="color: white !important;"
                >
                  {{ service_name }}
                </b-badge>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </b-modal>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BBadge, BPagination, BFormSelect, BDropdown, BDropdownItem, BCol, BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BBadge,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCol,
    BRow,
  },
  data() {
    return {
      pageLength: 25,
      dir: false,
      selectedData: {},
      aggregatorServices: [],
      columns: [
      {
          label: 'Megnevezés',
          field: 'name',
        },
        {
          label: 'Gyártó',
          field: 'brand',
        },
        {
          label: 'Típus',
          field: 'type',
        },
        {
          label: 'Gyári szám',
          field: 'manufacturing_number',
        },
        {
          label: 'Üzemóra',
          field: 'operating_hours',
        },
        {
          label: 'Következő szervíz',
          field: 'service',
        },
        {
          label: 'Műveletek',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  mounted() {
    this.loadAggregatorList()
  },
  methods: {
    // Számítja a következő szervíz esedékességét üzemórában
    getNextServiceHours(aggregator) {
      if (aggregator.last_service) {
        // Ha van előző szervíz, akkor az üzemóra + intervallum
        return parseInt(aggregator.last_service.hour_at_the_time_of_service, 10) + parseInt(aggregator.last_service.service_interval, 10)
      }
      // Ha nincs előző szervíz, akkor az eredeti szervíz intervallum
      return parseInt(aggregator.service_interval, 10) || 0
    },

    // Megjelenítendő szöveg a következő szervízhez
    getNextServiceText(aggregator) {
      const nextServiceHours = this.getNextServiceHours(aggregator)

      if (nextServiceHours <= 0) {
        return 'Nincs adat'
      }

      return `${nextServiceHours} óra`
    },

    deleteThisAggregator(id) {
      axios({
        method: 'delete',
        url: `aggregator/delete/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres törlés!',
            text: 'Az aggregátor törölve lett.',
            variant: 'success',
          },
        })
        this.loadAggregatorList()
      })
    },
    loadAggregatorList() {
      axios({
        method: 'get',
        url: 'aggregator/list',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.rows = response.data
      })
    },

    getAggregatorDetails(id) {
      // Aggregator services lekérése
      axios({
        method: 'get',
        url: `aggregator/${id}/service/list`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.aggregatorServices = response.data
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
